<template>
  <div
    class="form-section"
    :class="sectionClasses"
  >
    <div class="form-section__container">
      <div class="form-section__container-holder">
        <slot />
        <transition name="fade">
          <span
            v-if="!noValidity"
            class="form-section__validity"
          >
            <v-icon
              class="icon"
              size="30"
              :color="validityColor"
            >
              {{ icon }}
            </v-icon>
          </span>
        </transition>
      </div>
    </div>

    <v-overlay
      absolute
      opacity="0.2"
      :value="isLoading"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: 'form-section',
  props: {
    noValidity: {
      type: Boolean,
      default: false,
    },
    validated: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: true,
    },
    touched: {
      type: Boolean,
      default: false,
    },
    dirty: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      icons: {
        check: 'mdi-check-circle',
        fail: 'mdi-close-circle',
        incomplete: 'mdi-circle-slice-5',
      },
    };
  },
  computed: {
    icon () {
      if (this.validated) return this.valid ? this.icons.check : this.icons.fail;
      if (this.touched) return this.valid ? this.icons.check : this.icons.incomplete;
      return this.icons.check;
    },
    sectionClasses () {
      const classes = {
        'is-failed': this.validated && !this.valid,
        'is-passed': this.validated && this.valid,
      };
      if (!this.noValidity) {
        return Object.assign(classes, {
          'is-dirty': this.touched,
          'is-valid': this.valid,
          'is-invalid': !this.valid,
        });
      }
      return classes;
    },
    validityColor () {
      if (this.validated) return this.$vuetify.theme.themes.light[this.valid ? 'success' : 'error'];
      return this.valid ? this.$vuetify.theme.themes.light.success : '#6b757d';
    },
  },
};
</script>

<style lang="scss" scoped>
.form-section {
  $padding-top: _percentage(50px, 934px);
  $padding_side: _percentage(100px, 934px);

  position: relative;
  background-color: $clr-white;

  &.is-failed {
    z-index: 1;
  }

  &__container {
    margin: -1px 0;
    padding: calc(#{$padding-top * 1.5} + 1px) $padding_side / 2;

    &-holder {
      position: relative;
      padding-right: 0;
    }

    &::before {
      content: '';
      display: none;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      opacity: 0.04;
    }

    & > * {
      position: relative;
      z-index: 1;
    }
  }

  &__validity {
    position: absolute;
    top: 0;
    right: 0;
    color: #dadada;
  }

  &.is-failed &__container::before {
    display: block;
    background-color: var(--v-error-base, $clr-error);
  }

  & + & {
    &::before {
      content: '';
      display: block;
      height: 1px;
      background-color: #d0d1d8;
      margin: 0 $padding_side;
    }
  }

  @media screen and (min-width: 768px) {
    &__container {
      padding: calc(#{$padding-top} + 1px) $padding_side;

      &-holder {
        padding-right: calc(#{$tick_distance});
      }
    }
  }
}

</style>
